import { useLocation } from 'react-router';
import { useAuth } from 'react-oidc-context';
import { TARGET_DESTINATION } from '@legacy/constants/localstorage';
import { loginPortalUrl } from '@legacy/utils/url/loginPortalUrl';
import { ReactElement } from 'react';

interface AuthRouteProps {
  children: ReactElement;
}

const getRedirectPath = (
  pathname: string,
  accessToken?: string,
): 'children' | 'login' => {
  if (accessToken) {
    return 'children';
  }

  localStorage.setItem(TARGET_DESTINATION, pathname);

  return 'login';
};

export const getRedirectPathForTest = getRedirectPath;

export const AuthRoute = ({ children }: AuthRouteProps) => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const accessToken = user?.access_token;

  const result = getRedirectPath(pathname, accessToken);

  if (result === 'login') {
    window.location.href = loginPortalUrl;
    return null;
  }

  return children;
};
